// ** React Imports
// ** Custom Components
import NavbarSearchWrapper from "./NavbarSearchWrapper";

const ThemeNavbar = (props) => {
  return <NavbarSearchWrapper />;
};

export default ThemeNavbar;
